import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import utc from 'dayjs/plugin/utc';

import { getPassesAction } from '@/store/api-actions/get-passes';
import {
	setClientId,
	setPasses,
	setPerson,
	setReplacedPersonId,
	setUser,
} from '@/store/user-process/user-process';

import { isAdmin, isModerator } from '@/shared/helpers/isAdmin';
import useUserStore from '@/shared/store/user.store.ts';
import { AutorizationResponseType } from '@/shared/types/app.types';
import { IPersonPass } from '@/shared/types/passes.types';
import { IUser } from '@/shared/types/user.types';

import { store } from '@/store';

export const init = () => {
	dayjs.locale('ru');
	dayjs.extend(isToday);
	dayjs.extend(utc);

	const userRaw = localStorage.getItem('user');
	const personRaw = localStorage.getItem('person');
	const passesRaw = localStorage.getItem('passes');

	const {
		setUser: setZustandUser,
		setSession,
		setPasses: setZustandPasses,
		setTargetPersonId,
		setIsAdmin,
		setIsModerator,
	} = useUserStore.getState();

	if (userRaw && userRaw !== 'undefined') {
		const user = JSON.parse(userRaw) as AutorizationResponseType;
		const person = personRaw && personRaw !== 'undefined' ? (JSON.parse(personRaw) as IUser) : null;
		const passes =
			passesRaw && passesRaw !== 'undefined' ? (JSON.parse(passesRaw) as IPersonPass[]) : [];
		const personId = user.user?.person_id ?? null;

		setSession(user);
		setZustandPasses(passes);
		setTargetPersonId(personId);
		setIsAdmin(Boolean(isAdmin(user)));
		setIsModerator(Boolean(isModerator(passes)));

		if (person) {
			setZustandUser(person);
		}

		store.dispatch(setUser(user));
		store.dispatch(setClientId(personId));
		store.dispatch(setReplacedPersonId(personId));
		store.dispatch(setPasses(passes));
		void store.dispatch(getPassesAction());

		if (person) {
			store.dispatch(setPerson(person));
		}
	}
};
